(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["delivery-estimate"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('delivery-estimate')) {
    class DeliveryEstimate extends HTMLElement {
      connectedCallback() {
        if (!window.ppDelivery) return;
        const d = this.dataset;
        this.config = window.ppDelivery.readConfig(this);
        this.countdownTemplate = d.tplCountdown || '';
        this.slots = {
          date: this.querySelector('[data-slot="date"]'),
          countdown: this.querySelector('[data-slot="countdown"]'),
          occasion: this.querySelector('[data-slot="occasion"]'),
        };

        this.update = this.update.bind(this);
        this.onVisibility = () => {
          if (!document.hidden) this.update();
        };

        this.update();
        this.timer = setInterval(this.update, 30000);
        document.addEventListener('visibilitychange', this.onVisibility);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
        document.removeEventListener('visibilitychange', this.onVisibility);
      }

      fillTemplate(element, template, token, value) {
        if (!template.includes(token)) {
          element.textContent = template;
          return;
        }
        const [before, after] = template.split(token);
        const strong = document.createElement('strong');
        strong.textContent = value;
        element.replaceChildren(before, strong, after);
      }

      update() {
        const core = window.ppDelivery;
        const result = core.compute(this.config);

        this.slots.date.textContent = core.formatRange(result.earliest, result.latest);

        if (result.beforeCutoff && this.countdownTemplate) {
          this.fillTemplate(this.slots.countdown, this.countdownTemplate, '{countdown}', core.formatCountdown(result.minutesLeft));
          this.slots.countdown.hidden = false;
        } else {
          this.slots.countdown.hidden = true;
        }

        if (this.slots.occasion) {
          const hit = core.activeOccasion ? core.activeOccasion(result) : null;
          const text = this.slots.occasion.querySelector('[data-occasion-text]');
          if (hit && text) text.textContent = (text.dataset.tpl || 'Kommt rechtzeitig zu {occasion} an').replace('{occasion}', hit.label);
          this.slots.occasion.hidden = !hit;
        }

        this.dataset.state = result.beforeCutoff ? 'before-cutoff' : 'after-cutoff';
      }
    }

    customElements.define('delivery-estimate', DeliveryEstimate);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pp-card-upsell"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pp-card-upsell')) {
    class PpCardUpsell extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.handleClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
      }

      handleClick = (event) => {
        const button = event.target.closest('button[data-variant-id]');
        if (!button || button.disabled) return;
        this.addToCart(button);
      };

      get source() {
        if (this.dataset.source) return this.dataset.source;
        return this.closest('.pp-cart-offer') ? 'cart_set_offer' : 'pdp_card_upsell';
      }

      track(variantId) {
        const detail = { source: this.source, variantId };
        this.dispatchEvent(new CustomEvent('pp:upsell:add', { bubbles: true, detail }));
        try {
          if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
            window.Shopify.analytics.publish('pp_upsell_add', detail);
          }
        } catch (error) {
          /* Analytics duerfen den Kauf nie blockieren */
        }
      }

      async fetchCart() {
        const cartItems = document.querySelector('cart-items-component');
        if (cartItems) {
          await customElements.whenDefined('cart-items-component');
          if (typeof cartItems.fetchCartData === 'function') return cartItems.fetchCartData();
        }
        const cartUrl = (window.Theme && window.Theme.routes && window.Theme.routes.cart_url) || '/cart';
        const response = await fetch(`${cartUrl}.json`, { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
        return response.json();
      }

      async addToCart(button) {
        const status = this.querySelector('.pp-upsell__status');
        const label = button.querySelector('.pp-upsell__add-label');
        const variantId = Number(button.dataset.variantId);
        const addUrl = (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || '/cart/add.js';
        const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
          .map((element) => element.dataset.sectionId)
          .filter(Boolean);

        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        if (status) status.textContent = '';

        let CartLinesUpdateEvent = null;
        let deferred = null;
        try {
          ({ CartLinesUpdateEvent } = await import('@shopify/events'));
          deferred = CartLinesUpdateEvent.createPromise();
          this.dispatchEvent(
            new CartLinesUpdateEvent({
              action: 'add',
              context: 'product',
              lines: [{ merchandiseId: String(variantId), quantity: 1 }],
              promise: deferred.promise,
            })
          );
        } catch (error) {
          CartLinesUpdateEvent = null;
          deferred = null;
        }

        try {
          const response = await fetch(addUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }], sections: sectionIds.join(',') }),
          });
          const data = await response.json();
          if (data.status) throw new Error(data.description || data.message || 'add failed');

          const cart = await this.fetchCart();
          if (deferred && CartLinesUpdateEvent) {
            deferred.resolve({
              cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
              detail: {
                items: cart.items,
                source: 'pp-card-upsell',
                itemCount: 1,
                sections: data.sections,
                didError: false,
              },
            });
          }

          button.dataset.added = 'true';
          if (label) label.textContent = this.dataset.addedLabel;
          if (status) status.textContent = '';
          this.track(variantId);
        } catch (error) {
          console.error('[pp-card-upsell]', error);
          if (deferred) deferred.reject(error);
          button.disabled = false;
          if (status) status.textContent = this.dataset.errorLabel;
        } finally {
          button.removeAttribute('aria-busy');
        }
      }
    }

    customElements.define('pp-card-upsell', PpCardUpsell);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pp-product-info"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pp-gpsr')) {
    class PpGpsr extends HTMLElement {
      connectedCallback() {
        const source = this.querySelector('script[type="application/json"]');
        const output = this.querySelector('[data-gpsr-output]');
        if (!source || !output || output.childElementCount > 0) return;

        let data = null;
        try {
          data = JSON.parse(source.textContent);
        } catch (error) {
          return;
        }

        const groups = [
          ['SafetyInformation', this.dataset.safetyLabel],
          ['WarningInformation', this.dataset.warningLabel],
        ];

        for (const [key, label] of groups) {
          const raw = data && typeof data[key] === 'string' ? data[key] : '';
          const lines = raw
            .split(/<br\s*\/?>/i)
            .map((line) => line.replace(/^\s*-\s*/, '').trim())
            .filter(Boolean);
          if (lines.length === 0) continue;

          const heading = document.createElement('p');
          heading.className = 'pp-info__subhead';
          heading.textContent = label;

          const list = document.createElement('ul');
          for (const line of lines) {
            const item = document.createElement('li');
            item.textContent = line;
            list.append(item);
          }

          output.append(heading, list);
        }
      }
    }

    customElements.define('pp-gpsr', PpGpsr);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pp-sticky-atc"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pp-sticky-atc')) {
    const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    const priceFormatter = new Intl.NumberFormat('de-DE', { style: 'currency', currency });

    class PpStickyAtc extends HTMLElement {
      connectedCallback() {
        const scope = this.closest('.shopify-section') || document;
        this.target =
          scope.querySelector('.product-form-buttons button[name="add"]') ||
          scope.querySelector('.product-form-buttons [ref="addToCartButton"]') ||
          scope.querySelector('.product-form-buttons');
        this.button = this.querySelector('.pp-satc__btn');
        this.price = this.querySelector('[data-price]');
        if (!this.target || !this.button || !('IntersectionObserver' in window)) return;

        this.button.addEventListener('click', this.handleClick);
        document.addEventListener('variant:update', this.handleVariant);

        this.observer = new IntersectionObserver(([entry]) => {
          this.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
        });
        this.observer.observe(this.target);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.button) this.button.removeEventListener('click', this.handleClick);
        document.removeEventListener('variant:update', this.handleVariant);
      }

      handleClick = () => {
        const canAdd = this.dataset.mode === 'add' && this.target.tagName === 'BUTTON' && !this.target.disabled;
        if (canAdd) {
          this.target.click();
        } else {
          this.target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      };

      handleVariant = (event) => {
        const variant = event.detail && event.detail.resource;
        if (variant && typeof variant.price === 'number' && this.price) {
          this.price.textContent = priceFormatter.format(variant.price / 100);
        }
      };
    }

    customElements.define('pp-sticky-atc', PpStickyAtc);
  }
  } catch(e) { console.error(e); }
})();

})();
